export class AddCharacteristicErrorResponse {
  name: any;
  characteristicName: any;
}
